import angular from 'angular'

angular.module('nominas.nomina')
  .service('NominasNominaRecibos', NominasNominaRecibos)

function NominasNominaRecibos($api, $http, $q) {
  this.get = get
  this.generar = generar
  this.generarUrl = generarUrl
  this.descargar = descargar

  function get(idNomina) {
    return $api.get('kendu/nominas/nomina/recibos', {
      idNomina: idNomina,
    }, {cache: 'nominas'})
  }

  function generar(idEmpresa, idEmpleado, idNomina) {
    return $api.get('kendu/nominas/nomina/recibos/generar', {
      idEmpresa: idEmpresa,
      idEmpleado: idEmpleado,
      idNomina: idNomina,
    })
  }

  function generarUrl(idEmpresa, idEmpleado, idNomina) {
    return $api.link('kendu/nominas/nomina/recibos/generar', {
      idEmpresa: idEmpresa,
      idEmpleado: idEmpleado,
      idNomina: idNomina,
    })
  }

  function descargar(idEmpresa, idEmpleado, idNomina, enviarEmail) {
    return $http.get('kendu/nominas/nomina/recibos/descargar', {
      params: {
        idEmpresa: idEmpresa,
        idEmpleado: idEmpleado,
        idNomina: idNomina,
        enviarEmail: enviarEmail,
      },
      responseType: 'arraybuffer',
    }).catch(function (response) {
      response.data = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(response.data)))
      return $q.reject(response)
    })
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Recibos.js